import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

const CFG = {
  success: {
    icon: '✓',
    iconBg: '#dcfce7',
    iconColor: '#16a34a',
    accent: '#16a34a',
    defaultTitle: 'Éxito',
  },
  error: {
    icon: '✕',
    iconBg: '#fee2e2',
    iconColor: '#dc2626',
    accent: '#dc2626',
    defaultTitle: 'Error',
  },
  confirm: {
    icon: '?',
    iconBg: '#dbeafe',
    iconColor: '#2563eb',
    accent: '#2563eb',
    defaultTitle: 'Confirmar',
  },
};

const Modal = ({ isOpen, type = 'success', title, message, onAccept, onCancel, onClose }) => {
  const btnRef = useRef(null);
  const cfg = CFG[type] || CFG.success;

  useEffect(() => {
    if (isOpen && btnRef.current) btnRef.current.focus();
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    const fn = (e) => {
      if (e.key === 'Escape') {
        type === 'confirm' && onCancel ? onCancel() : onClose && onClose();
      }
    };
    window.addEventListener('keydown', fn);
    return () => window.removeEventListener('keydown', fn);
  }, [isOpen, type, onCancel, onClose]);

  if (!isOpen) return null;

  const handleOverlay = (e) => {
    if (e.target !== e.currentTarget) return;
    type === 'confirm' && onCancel ? onCancel() : onClose && onClose();
  };

  const S = {
    overlay: {
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,0.45)',
      zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '16px',
    },
    card: {
      background: '#fff',
      borderRadius: '12px',
      boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
      width: '100%', maxWidth: '420px',
      padding: '36px 32px 28px',
      position: 'relative',
      borderTop: `4px solid ${cfg.accent}`,
    },
    iconWrap: {
      width: 56, height: 56, borderRadius: '50%',
      background: cfg.iconBg,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      margin: '0 auto 20px',
    },
    icon: { fontSize: '26px', fontWeight: 700, color: cfg.iconColor, lineHeight: 1 },
    title: {
      textAlign: 'center', fontSize: '19px', fontWeight: 700,
      color: '#111827', margin: '0 0 10px',
    },
    message: {
      textAlign: 'center', fontSize: '14px', color: '#6b7280',
      lineHeight: 1.6, margin: '0 0 28px', whiteSpace: 'pre-line',
    },
    buttons: { display: 'flex', justifyContent: 'center', gap: '12px' },
    btnAccept: {
      padding: '10px 28px', borderRadius: '8px', border: 'none',
      background: cfg.accent, color: '#fff',
      fontSize: '14px', fontWeight: 600, cursor: 'pointer',
      minWidth: '100px', transition: 'filter 0.15s',
    },
    btnCancel: {
      padding: '10px 28px', borderRadius: '8px', border: 'none',
      background: '#f3f4f6', color: '#374151',
      fontSize: '14px', fontWeight: 600, cursor: 'pointer',
      minWidth: '100px', transition: 'filter 0.15s',
    },
    closeX: {
      position: 'absolute', top: 14, right: 16,
      background: 'none', border: 'none',
      fontSize: '20px', color: '#9ca3af', cursor: 'pointer',
      lineHeight: 1, padding: '2px 6px', borderRadius: '4px',
    },
  };

  return ReactDOM.createPortal(
    <div style={S.overlay} onClick={handleOverlay}>
      <div style={S.card} role="dialog" aria-modal="true">

        {/* X esquina superior */}
        <button style={S.closeX} onClick={type === 'confirm' ? onCancel : onClose} aria-label="Cerrar">×</button>

        {/* ícono circular */}
        <div style={S.iconWrap}><span style={S.icon}>{cfg.icon}</span></div>

        {/* título */}
        <h3 style={S.title}>{title || cfg.defaultTitle}</h3>

        {/* mensaje */}
        {message && <p style={S.message}>{message}</p>}

        {/* botones */}
        <div style={S.buttons}>
          {type === 'confirm' && (
            <button style={S.btnCancel} onClick={onCancel}>Cancelar</button>
          )}
          <button
            style={S.btnAccept}
            ref={btnRef}
            onClick={onAccept}
            onMouseEnter={(e) => e.target.style.filter = 'brightness(0.9)'}
            onMouseLeave={(e) => e.target.style.filter = 'none'}
          >
            {type === 'confirm' ? 'Confirmar' : 'Aceptar'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
